import { getDiscoCompanyMenuItems } from "../../components/AdminCompanySelect/DiscoCompanyMenuItems";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import AppLoader from '../../components/AppLoader/AppLoader';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import eOpsLogo from "../../images/eops.png";
import { cfpBaseUrl } from "../../network/urls";
import { openJsPdfInNewTab, convertDate,
  convertDatewithTime,
  getName,
} from "../../services/Functions";
import "../../style/common.scss";
import ReportExportButtons from "./components/ReportExportButtons";
import "./reportPageLayout.scss";
import "./ChangeOfAttributesStatusReport.scss";
import "./TariffWiseAnalysisOfBillingAndCollectionReport.scss";
import {
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../images/pitc.png';
import { getEffectiveAdminCompanyCode, getInitialAdminOfficeCode, resolveOfficeCodeForAdmin, resolveReportGoOfficeCode } from "../../utils/adminCompany";
const TariffWiseAnalysisOfBillingAndCollectionReport = () => {
    const tableRef = useRef(null);
    const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, selectedAdminCompanyCode } = useSelector(state => state.auth)
    const offCode = code;
    const companyCode = code.slice(0, 2)
    const [selectedCompanyCode, setSelectedCompanyCode] = useState(
      getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
    );
    const [circleCode, setCircleCode] = useState('');
    const [circleName, setCircleName] = useState('');
    const [officeCode, setOfficeCode] = useState();
    const [officeName, setOfficeName] = useState('');
    const [selectedDivision, setSelectedDivision] = useState('');
    const [selectedSubDivision, setSelectedSubDivision] = useState('');
    useEffect(() => {
      if (String(code) === "10" && selectedAdminCompanyCode) {
        const company = String(selectedAdminCompanyCode);
        setSelectedCompanyCode(company);
        setOfficeCode(company);
      }
    }, [code, selectedAdminCompanyCode]);

    useEffect(() => {
      if (String(code) !== "10") return;
      if (circleCode || selectedDivision || selectedSubDivision) return;
      const company = getEffectiveAdminCompanyCode(
        code,
        selectedCompanyCode,
        selectedAdminCompanyCode,
      );
      if (company) {
        setOfficeCode(company);
      }
    }, [
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    ]);
    const [filteredDivisions, setFilteredDivisions] = useState([]);
    const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
    const [hierarchy, setHierarchy] = useState('');
       const [apiData, setApiData] = useState([]);
    const [filteredCircles, setFilteredCircles] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false); // State to track loading
    const [error, setError] = useState(null);
      const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);

         const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
    const connectionTypes = [
        'Office Code',
        'Office Name',
        'Category',
        'Domestic',
        'Commercial',
        'General',
        'Industrial',
        'Agricultural',
        'Others',
        'Private',
        'Govt.',
        'Total'
    ];

    const fetchData = async (officeCode) => {
        try {
            setLoading(true);
            const url = `https://ibs-dashboard-data-api.pitc.com.pk/api/v1/common?apiName=eops_mis_stat_1a&P_OFC_CODE=${officeCode}`;
            const response = await fetch(url, {
                method: "GET",
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            if (result?.rows) {
                const data = result.rows
                const array2Digits = data.filter(item => item.OFC_CODE.length === 2);
                const array3Digits = data.filter(item => item.OFC_CODE.length === 3);
                const array4Digits = data.filter(item => item.OFC_CODE.length === 4);
                const array5Digits = data.filter(item => item.OFC_CODE.length === 5);
                const combinedArray = [];
                const uniquePrefixes4Digits = [...new Set(array5Digits.map(item => item.OFC_CODE.substring(0, 4)))];
                uniquePrefixes4Digits.forEach(prefix => {
                    const matching5Digits = array5Digits.filter(item => item.OFC_CODE.startsWith(prefix));
                    combinedArray.push(...matching5Digits);
                    const matching4Digit = array4Digits.find(item => item.OFC_CODE === prefix);
                    if (matching4Digit) {
                        combinedArray.push(matching4Digit);
                    }
                });
                const uniquePrefixes3Digits = [...new Set(array5Digits.map(item => item.OFC_CODE.substring(0, 3)))];
                uniquePrefixes3Digits.forEach(prefix => {
                    const matching3Digit = array3Digits.find(item => item.OFC_CODE === prefix);
                    if (matching3Digit) {
                        const lastMatchingIndex = combinedArray.reduce((lastIndex, item, index) => {
                            return item.OFC_CODE.startsWith(prefix) ? index : lastIndex;
                        }, -1);
                        combinedArray.splice(lastMatchingIndex + 1, 0, matching3Digit);
                    }
                });
                combinedArray.push(...array2Digits);
                if (combinedArray) {
                    setData(combinedArray);
                    setLoading(false)
                }
            } else {
                setData([]);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    function getCurrentDateFormatted(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const options = { month: 'short' };
        const month = date.toLocaleString('en-US', options);
        const year = String(date.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
    }

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setLoading(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', token);
        const formdata = new FormData();
        formdata.append('companyCode', selectedCompanyCode);
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow',
        };
        try {
          const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
          if (response.ok) {
            const result = await response.json();
            if (result.status === '200') {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some(item => item.circleCode === curr.circleCode)) {
                  acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setLoading(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some(item => item.circleCode === curr.circleCode)) {
          acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || '');

    if (code == 10 && selectedCompany) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompany);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setCircleName('');
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some(item => item.circleCode === curr.circleCode)) {
                acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setLoading(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName('PITC');
      setCircleCode('');
      setSelectedDivision('');
      setSelectedSubDivision('');
      setCircleName('');
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('circleCode', selectedCircleCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
            const circleName = circle?.circleName || '';
            setOfficeName(circleName.concat(' Circle'));
            setCircleName(circleName);
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter(item => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                  acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode('');
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
      const circleName = circle?.circleName || '';
      setOfficeName(circleName.concat(' Circle'));
      setCircleName(circleName);
      setSelectedDivision('');
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(item => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (!acc.some(division => division.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode('');
      setSelectedDivision('');
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      if (roleTypeName == 'Technical') {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
          setOfficeName(officeName.concat(' Region'));
          setCircleName('');
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some(item => item.circleCode === curr.circleCode)) {
              acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == 'Commercial') {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('divisionCode', selectedDivisionCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
            const divisionName = division?.divisionName || '';
            setOfficeName(divisionName.concat(' Division'));
            setSelectedSubDivision('');
            const uniqueSubDivisions = result.message
              .filter(item => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                  acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
      setOfficeName(divisionName.concat(' Division'));
      setSelectedSubDivision('');
      const uniqueSubDivisions = subDivisions
        .filter(item => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
            acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision('');
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
      setOfficeName(officeName.concat(' Circle'));
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
        .reduce((acc, item) => {
          if (!acc.some(division => division.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('subDivisionCode', selectedSubDivisionCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
            const subDivisionName = subDivision?.subDivisionName || '';
            setOfficeName(subDivisionName.concat(' Sub Division'));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
      setOfficeName(subDivisionName.concat(' Sub Division'));
    } else {
      setSelectedSubDivision('');
      let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
      setOfficeName(officeName.concat(' Division'));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == 'Technical') {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == 'Commercial') {
      if (cfcLevelId == 1) {
       if (offCode) {
                            if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);  
                        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some(item => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some(item => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter(item => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter(item => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
              acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);
    
    const formatSDIVCode = (code) => {
        return code.length < 5 ? code.padEnd(5, "0") : code;
    };

    // const shouldHighlightRow = (code) => {
    //     return code.endsWith("0") && !code.endsWith("00"); // Check if ends with a single zero
    // };
    const shouldHighlightRow = (code) => {
        const trailingZeros = code.match(/0+$/)?.[0]?.length || 0;
        if (trailingZeros === 1) {
            return "#ccecf9";
        } else if (trailingZeros === 2) {
            return "#c5ddf9";
        } else if (trailingZeros === 3) {
            return "#8ac6f7"
        }
        return null;
    };

    function formatToMillions(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2, // Fixed to 2 decimal places
            maximumFractionDigits: 2,
        }).format(value / Math.pow(10, 6)); // Convert value to millions
    }
    const getLogo = (code) => {
        switch (code) {
            case '10':
                return pitcLogo
            case '11':
                return LESCOLOGO
            case '12':
                return GEPCOLOGO
            case '13':
                return FESCOLOGO
            case '14':
                return IESCOLOGO
            case '15':
                return MEPCOLOGO
            case '26':
                return PESCOLOGO
            case '27':
                return HAZECOLOGO
            case '37':
                return HESCOLOGO
            case '38':
                return SEPCOLOGO
            case '48':
                return QESCOLOGO
            case '59':
                return TESCOLOGO
            default:
                return MEPCOLOGO
        }
    }
    const getCompanies = (code) => {
        switch (code) {
            case '10':
                return "Power Information Technology Company"
            case '11':
                return "Lahore Electric Supply Company"
            case '12':
                return "Gujranwala Electric Power Company"
            case '13':
                return "Faisalabad Electric Supply Company"
            case '14':
                return "Islamabad Electric Supply Company"
            case '15':
                return "Multan Electric Power Company"
            case '26':
                return "Peshawar Electric Supply Company"
            case '27':
                return "Hazara Electric Supply Company"
            case '38':
                return "Sukkur Electric Power Company"
            case '37':
                return "Hyderabad Electric Supply Company"
            case '48':
                return "Quetta Electric Supply Company"
            case '59':
                return "Tribal Electric Supply Company"

        }
    }
    const DownloadPdf = async (print) => {
        return new Promise((resolve, reject) => {
            let offName = officeName;
            let dateToPrint = getCurrentDateFormatted(new Date);

            // Define header structure
            const headers = connectionTypes.map((type) => ({ content: type, styles: { halign: 'left' } }));

            // Map rows
            const rows = data.map((item) => {
                const code = formatSDIVCode(item.OFC_CODE);
                return [
                    [
                        code,
                        item.OFC_NAME,
                        "Assessment",
                        formatWithCommasAndFixed(item.DOM_ASS),
                        formatWithCommasAndFixed(item.COM_ASS),
                        formatWithCommasAndFixed(item.GEN_ASS),
                        formatWithCommasAndFixed(item.IND_ASS),
                        formatWithCommasAndFixed(item.AGR_ASS),
                        formatWithCommasAndFixed(item.OTH_ASS),
                        formatWithCommasAndFixed(item.PVT_ASS),
                        formatWithCommasAndFixed(item.GVT_ASS),
                        formatWithCommasAndFixed(item.TOT_ASS),
                    ],
                    [
                        code,
                        item.OFC_NAME,
                        "Payment",
                        formatWithCommasAndFixed(item.DOM_PAY),
                        formatWithCommasAndFixed(item.COM_PAY),
                        formatWithCommasAndFixed(item.GEN_PAY),
                        formatWithCommasAndFixed(item.IND_PAY),
                        formatWithCommasAndFixed(item.AGR_PAY),
                        formatWithCommasAndFixed(item.OTH_PAY),
                        formatWithCommasAndFixed(item.PVT_PAY),
                        formatWithCommasAndFixed(item.GVT_PAY),
                        formatWithCommasAndFixed(item.TOT_PAY),
                    ],
                    [
                        code,
                        item.OFC_NAME,
                        "Percentage",
                        formatWithCommasAndFixed((item.DOM_PAY / item.DOM_ASS) * 100),
                        formatWithCommasAndFixed((item.COM_PAY / item.COM_ASS) * 100),
                        formatWithCommasAndFixed((item.GEN_PAY / item.GEN_ASS) * 100),
                        formatWithCommasAndFixed((item.IND_PAY / item.IND_ASS) * 100),
                        formatWithCommasAndFixed((item.AGR_PAY / item.AGR_ASS) * 100),
                        formatWithCommasAndFixed((item.OTH_PAY / item.OTH_ASS) * 100),
                        formatWithCommasAndFixed((item.PVT_PAY / item.PVT_ASS) * 100),
                        formatWithCommasAndFixed((item.GVT_PAY / item.GVT_ASS) * 100),
                        formatWithCommasAndFixed((item.TOT_PAY / item.TOT_ASS) * 100),
                    ]
                ];
            }).flat();

            // Debugging logs



            // Initialize PDF and set basic layout
            const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 25 : 30;
            const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 20 : 10;
            pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

            const eOpsLogoWidth = 20;
            const eOpsLogoHeight = 8;
            const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 43 : 17;
            pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' | companyCode === '27' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);


            pdf.setFontSize(10);
            pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
            pdf.text("Name: " + name, pageWidth - 65, 17);
            pdf.text("Designation: " + roleName, pageWidth - 65, 22);


            pdf.setFontSize(12);
            pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.text('Tariff Wise Analysis Of Computed Billing, Collection & Percentage Report', pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(10);
            pdf.text(`Tariff Wise Analysis Of Computed Billing, Collection & Percentage Report for ${offName} of ${dateToPrint}`, pageWidth / 2, 25, { align: 'center' });

            // Generate table in PDF
            pdf.autoTable({
                startY: 28,
                head: [headers],
                body: rows,
                styles: {
                    cellPadding: 1,
                    fontSize: 8,
                    halign: 'center',
                    lineWidth: 0.25,
                    lineColor: 'white'
                },
                margin: { top: 2 },
                theme: 'striped',
                headStyles: { valign: 'middle' },
                bodyStyles: {
                    halign: 'center', // Default alignment for all columns
                },
                columnStyles: {
                    0: { halign: 'left' }, // Align the first column ("Region Name") to the left
                },
                didParseCell: (data) => {
                    // Check if it's the "final row for ParentNode Totals"
                    if (data.row.raw[0] === "Total") {
                        data.cell.styles.fontStyle = 'bold'; // Make the font bold
                    }
                },
            });
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                const pageNumberText = `Page ${i} of ${totalPages}`;
                pdf.setFontSize(10);
                pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
            }

            // Save or download the PDF
            if (print) {
                openJsPdfInNewTab(pdf, `${offName}-${dateToPrint}-Collection-Vs-Computed Assessment-(Category Wise).pdf`);
            } else {
                resolve(pdf);
            }
        });
    };
    const exportToExcel = () => {
        let offName = officeName
        let dateToPrint = convertDate(new Date());
        const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: 'Sheet1' });
        boldDomTheadRows(wb.Sheets[wb.SheetNames[0]], tableRef.current, 0);
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout]), `${offName}-${dateToPrint} -Collection-Vs-Computed Assessment-(Category Wise).xlsx`);
    };

    const printPDF = async () => {
        let pdf = await DownloadPdf(false);
        const pdfUrl = pdf.output('bloburl');

        // Create an iframe
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.src = pdfUrl;
        document.body.appendChild(iframe);

        // Create a cancel button
        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.style.position = 'fixed';
        cancelButton.style.top = '20px';
        cancelButton.style.right = '20px';
        cancelButton.style.padding = '10px 20px';
        cancelButton.style.backgroundColor = '#ff4d4d';
        cancelButton.style.color = 'white';
        cancelButton.style.border = 'none';
        cancelButton.style.borderRadius = '5px';
        cancelButton.style.cursor = 'pointer';
        document.body.appendChild(cancelButton);

        // Print the PDF when the iframe loads
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        };

        // Remove iframe and cancel button when cancel button is clicked
        cancelButton.addEventListener('click', () => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
            if (cancelButton.parentNode) {
                document.body.removeChild(cancelButton);
            }
        });
    };

    function formatWithCommasAndFixed(value) {
        if (isNaN(value)) {
            return "0.00"; // Return default value if input is not a valid number
        }

        const number = parseFloat(value); // Ensure the value is a number
        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

  const currentFilters = {
    officeCode,
    ...(code == 10 ? { selectedCompanyCode } : {}),
    circleCode,
    selectedDivision,
    selectedSubDivision,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    officeCode,
    code,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    lastAppliedFilters,
  ]);

  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });
    fetchData(reportOfficeCode);
    setLastAppliedFilters({ ...currentFilters });
    setIsGoDisabled(true);
    setMobileFilterOpen(false);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{
        fontWeight: 600,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        lineHeight: 1.35,
      }}
    >
      {children}
    </Typography>
  );

  const tableCaptionText = `Computed Billing, Collection & Percentage Report for ${officeName || "—"} As Of (${getCurrentDateFormatted(new Date())}) - Rs. in Million`;

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid
      container
      spacing={2}
      alignItems="flex-start"
      className="coa-filters-grid-wrap"
    >
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="tw-company">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="tw-company"
                displayEmpty
                value={selectedCompanyCode || ""}
                onChange={(e) => {
                  handleChangeCompany(e);
                  setData([]);
                }}
              >
                <MenuItem value="">
                  <em>Select Company</em>
                </MenuItem>
                {getDiscoCompanyMenuItems(selectedCompanyCode)}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="tw-circle">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="tw-circle"
                displayEmpty
                value={
                  circleCode === "" ||
                  circleCode === undefined ||
                  circleCode === null
                    ? ""
                    : circleCode
                }
                onChange={(e) => {
                  handleCircleChange(e);
                  setData([]);
                }}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value="">
                  <em>All Circle</em>
                </MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>
                    {circle.circleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="tw-division">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="tw-division"
                displayEmpty
                value={
                  selectedDivision === "" ||
                  selectedDivision === undefined ||
                  selectedDivision === null
                    ? ""
                    : selectedDivision
                }
                onChange={(e) => {
                  handleDivisionChange(e);
                  setData([]);
                }}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value="">
                  <em>All Division</em>
                </MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem
                    key={division.divisionCode}
                    value={division.divisionCode}
                  >
                    {division.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="tw-subdiv">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="tw-subdiv"
                displayEmpty
                value={
                  selectedSubDivision === "" ||
                  selectedSubDivision === undefined ||
                  selectedSubDivision === null
                    ? ""
                    : selectedSubDivision
                }
                onChange={(e) => {
                  handleSubDivisionChange(e);
                  setData([]);
                }}
                disabled={!selectedDivision}
                renderValue={(v) =>
                  renderSubDivisionValue(v, filteredSubDivisions)
                }
              >
                <MenuItem value="">
                  <em>All Sub-Division</em>
                </MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem
                    key={subDivision.subDivisionCode}
                    value={subDivision.subDivisionCode}
                  >
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="tw-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || loading}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

    return (
        <>
            <Box className="form-box rpt-page coa-status-report tariff-wise-billing-collection-page">
                <div className="coa-layout">
                    <header className="coa-page-header">
                        <h1 className="coa-page-title">
                            Tariff Wise Analysis Of Computed Billing, Collection & Percentage Report
                        </h1>
                    </header>

                    <div className="coa-toolbar-stack">
                        <Paper
                            variant="outlined"
                            className="coa-card coa-card--filters"
                            sx={{
                                p: 2,
                                width: "100%",
                                bgcolor: "#fff",
                                borderRadius: 2,
                                borderColor: "divider",
                            }}
                        >
                            <div
                                className={
                                    isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                                }
                            >
                                {isMdUp ? (
                                    renderFilters({ showGo: true })
                                ) : (
                                    <p className="coa-filters-hint">
                                        Tap <strong>Filters</strong> to choose office, then tap{" "}
                                        <strong>GO</strong>.
                                    </p>
                                )}
                            </div>

                            <Stack
                                direction="row"
                                flexWrap="wrap"
                                alignItems="center"
                                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                                spacing={1}
                                className="coa-export-strip"
                                sx={{
                                    pt: 2,
                                    mt: 2,
                                    borderTop: "1px solid",
                                    borderColor: "divider",
                                    gap: 1,
                                }}
                            >
                                {!isMdUp && (
                                    <Tooltip title="Filters">
                                        <IconButton
                                            color="primary"
                                            onClick={() => setMobileFilterOpen(true)}
                                            aria-label="Open filters"
                                            size="small"
                                        >
                                            <FilterListIcon />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {!isMdUp && (
                                    <Button
                                        variant="contained"
                                        disableElevation
                                        className="coa-go-btn"
                                        size="small"
                                        onClick={handleGoClick}
                                        disabled={isGoDisabled || loading}
                                    >
                                        GO
                                    </Button>
                                )}
                                <ReportExportButtons
                                    isEmpty={data.length === 0}
                                    onEmpty={noDataAvailable}
                                    onPdf={() => DownloadPdf(true)}
                                    onExcel={exportToExcel}
                                    onPrint={printPDF}
                                />
                            </Stack>
                        </Paper>
                    </div>

                    <div className="coa-report-banner" role="status">
                        {tableCaptionText}
                    </div>

                    <Box
                        className="application-table"
                        sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
                    >
                        <div className="div-datagrid">
                            <div
                                className={
                                    "coa-table-panel" +
                                    (isPhone ? " coa-table-panel--hide-phone" : "")
                                }
                            >
                                <div className="coa-table-scroll" id="pdf-table">
                                <table
                                    ref={tableRef}
                                    className="coa-data-table table tariff-wise-bc-table"
                                >
                                    <thead>
                                        <tr>
                                            {connectionTypes.map((type, index) => (
                                                <th key={index}>{type}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr className="coa-loading-row">
                                                <td
                                                    colSpan={connectionTypes.length}
                                                    style={{ textAlign: "center", padding: "20px" }}
                                                >
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                    >
                                                        <AppLoader />
                                                    </Box>
                                                </td>
                                            </tr>
                                        ) : data.length === 0 ? (
                                            <tr className="coa-empty-row">
                                                <td
                                                    colSpan={connectionTypes.length}
                                                    style={{
                                                        textAlign: "center",
                                                        padding: "10px",
                                                        fontWeight: "bold",
                                                        color: "red",
                                                    }}
                                                >
                                                    No Data Found
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {data.map((item, rowIndex) => {
                                                        const codeVal = formatSDIVCode(item.OFC_CODE);
                                                        const highlightColor = shouldHighlightRow(codeVal);

                                                        const rowStyle = highlightColor
                                                            ? { backgroundColor: highlightColor, borderBottom: "1px solid #ccc" }
                                                            : { borderBottom: "1px solid #ccc" };

                                                        return (
                                                            <Fragment key={`${item.OFC_CODE}-${rowIndex}`}>
                                                                <tr style={rowStyle}>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {codeVal}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {item.OFC_NAME}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        Assessment
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.DOM_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.COM_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.GEN_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.IND_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.AGR_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.OTH_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.PVT_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.GVT_ASS)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.TOT_ASS)}
                                                                    </td>
                                                                </tr>
                                                                <tr style={rowStyle}>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {codeVal}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {item.OFC_NAME}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        Payment
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.DOM_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.COM_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.GEN_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.IND_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.AGR_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.OTH_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.PVT_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.GVT_PAY)}
                                                                    </td>
                                                                    <td style={{ padding: "5px", textAlign: "left", fontSize: "14px" }}>
                                                                        {formatWithCommasAndFixed(item.TOT_PAY)}
                                                                    </td>
                                                                </tr>
                                                                <tr style={rowStyle}>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {codeVal}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {item.OFC_NAME}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        Percentage
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed(((item.DOM_PAY / item.DOM_ASS) * 100) || 0)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed(((item.COM_PAY / item.COM_ASS) * 100) || 0)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.GEN_PAY / item.GEN_ASS) * 100)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.IND_PAY / item.IND_ASS) * 100)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.AGR_PAY / item.AGR_ASS) * 100)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.OTH_PAY / item.OTH_ASS) * 100)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.PVT_PAY / item.PVT_ASS) * 100)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.GVT_PAY / item.GVT_ASS) * 100)}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            padding: "5px",
                                                                            textAlign: "left",
                                                                            fontSize: "14px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        {formatWithCommasAndFixed((item.TOT_PAY / item.TOT_ASS) * 100)}
                                                                    </td>
                                                                </tr>
                                                            </Fragment>
                                                        );
                                                    })}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </Box>

                    <Drawer
                        anchor="left"
                        open={mobileFilterOpen}
                        onClose={() => setMobileFilterOpen(false)}
                        PaperProps={{
                            className: "coa-filter-drawer",
                            sx: {
                                width: { xs: "100%", sm: 400 },
                                maxWidth: "100vw",
                                boxSizing: "border-box",
                            },
                        }}
                    >
                        <Box
                            className="coa-drawer-inner"
                            sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{ mb: 2 }}
                            >
                                <Typography variant="h6" component="div">
                                    Filters
                                </Typography>
                                <IconButton
                                    aria-label="Close filters"
                                    onClick={() => setMobileFilterOpen(false)}
                                    edge="end"
                                    size="small"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Stack>
                            {renderFilters({ showGo: true })}
                        </Box>
                    </Drawer>
                </div>
            </Box>

        </>
    )
}

export default TariffWiseAnalysisOfBillingAndCollectionReport